import { defineMessages } from 'react-intl';

const trns = defineMessages({
  comfortableSearchLabelMob: {
    id: 'xAsQBq',
    defaultMessage: 'пошук препаратів за вигідною ціною'
  },
  comfortableSearchLabel: {
    id: 'z0P/27',
    defaultMessage: 'Знайдіть ліки за вигідною ціною в аптеках поруч'
  },
  comfortableSearchMessage: {
    id: 'f08pgU',
    defaultMessage:
      'LikiЄ - це сучасний портал для пошуку та бронювання ліків.  Зручний сервіс для тих, хто цінує свій час і не бажає бігати аптеками або переглядати сотні сайтів в інтернеті, заради пошуку потрібного препарата.'
  }
});

export default trns;
